import React from 'react';
import DateTimeSelector from '../DateTimeSelector/DateTimeSelector';

function getUSAStateOptionArray(operationalStates) {
  return Object.keys(operationalStates)
    .sort()
    .map((key) => {
      return {
        value: operationalStates[key].schema,
        label: operationalStates[key].state
      };
    });
}

export default function Header({
  stateSchema,
  handleStateSchemaChange,
  operationalStates,
  themeMode,
  minForecastPubTime,
  forecastPubTime,
  handleForecastPubTimeChange
}) {
  return (
    <>
      <span className='headerSpan'>
        <select
          id='usa-state-selector'
          defaultValue={stateSchema}
          value={stateSchema}
          onChange={(e) => {
            handleStateSchemaChange(e.target.value);
          }}
        >
          <option key='' value=''>
            Select a state
          </option>
          {getUSAStateOptionArray(operationalStates).map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {stateSchema !== '' ? (
          <DateTimeSelector
            themeMode={themeMode}
            minForecastPubTime={minForecastPubTime}
            forecastPubTime={forecastPubTime}
            handleForecastPubTimeChange={handleForecastPubTimeChange}
          />
        ) : null}

        <a
          href='https://github.com/Dewberry/fcast-dashboard'
          target='_blank'
          rel='noreferrer'
          title='GitHub repository'
        >
          <i className='fa fa-github fa-2x' id='git-icon'></i>
        </a>
        <a rel='noreferrer' href='/' title='Home & Info'>
          <i className='fa fa-home fa-2x' id='home-button'></i>
        </a>
      </span>
    </>
  );
}
